import {actionIds, BaseAction} from "../common";

const disconnectedAction: () =>
    BaseAction = () => ({
    type: actionIds.DISCONNECTED,
    payload: {},
});

export default disconnectedAction;
